<template>
            <div class="photobookIntro">
              <div class="photobookIntroImg">
                <img src="/img/photobookCover2020.jpg" srcset="/img/photobookCover2020@2x.jpg 2x" alt="東京カメラ部2020写真展 公式写真集">
              </div>
              <div class="photobookIntroTxt">
                <h2>This Cruel <br>Yet Beloved <br>World</h2>
                <h3>それでも世界は美しい。</h3>
                <h4>東京カメラ部2020写真展 公式写真集</h4>
                <p class="photobookPrice">定価：本体1,800円＋税</p>
                <a class="photobookButton" @click="logger('2020')" target="_blank" href="https://natgeo.nikkeibp.co.jp/atcl/product/20/080700025/">購入はこちらから<br><small>（発行元のサイトへリンクします）</small></a>
                <p class="photobookWheretobuy">全国有名書店ほか、Amazon、日経BPにて絶賛発売中！</p>
              </div>
            </div>
</template>

<script>
export default {
  methods: {
    logger (type) {
      // イベント記録
      this.$ga.event('Photobook', type, 'National Geographic', null)
    }
  }
}
</script>
